import { Component, Prop, Vue } from "vue-property-decorator";
import { Module } from "@/store/enums.ts";

import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import "@/styles/util.css";
import ComparisonChart from "@/components/ComparisonChart";

@Component
export default class ReadingTask1Intro extends Vue {
  private dialog = { show: false }; // to be able to mutate dialog as a prop within 'Comparison'.
  private balaTasks: any;

  constructor() {
    super();
    this.balaTasks = this.$store.getters.balaSections;
  }

  render(h: CreateElement) {
    return (
      <Card
        title={this.balaTasks[1].task + ": " + this.balaTasks[1].name}
        mod={Module.BALA}
        topButton={{
          label: "Comparison Chart",
          callbackfn: () => {
            this.dialog.show = true;
          }
        }}
      >
        <div
          slot="mainContent"
          class="subtitle-1"
          style={{ textAlign: "center" }}
        >
          <v-dialog v-model={this.dialog.show} content-class="cardDialog">
            <ComparisonChart
              dialog={this.dialog}
              readingTask={1}
            ></ComparisonChart>
          </v-dialog>
          <v-img
            src={require("@/assets/readingtask1.png")}
            max-width="300px"
            style={{ margin: "10px auto" }}
          ></v-img>
          Let's read the passage and answer some questions!
        </div>
        <div slot="actions">
          <v-btn color="secondary" to={{ name: "balaRT1Passage" }}>
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(this.$store.getters.progressBala)}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }
}

const component = ReadingTask1Intro;
